import { render, staticRenderFns } from "./WsDraggableSpeechBubble.vue?vue&type=template&id=0805f9ed&scoped=true"
import script from "./WsDraggableSpeechBubble.vue?vue&type=script&lang=ts"
export * from "./WsDraggableSpeechBubble.vue?vue&type=script&lang=ts"
import style0 from "./WsDraggableSpeechBubble.vue?vue&type=style&index=0&id=0805f9ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0805f9ed",
  null
  
)

export default component.exports